module.exports = __webpack_public_path__ + "static/img/s26.14bdc182.png";